export enum EPolicyUrls {
  POLICY = 'policy',
  DOC = 'doc',
  POLICY_CONTENT_SUGGESTION = 'policy-content-suggestion',
  APPLICATION_SAMPLE_TEMPLATE = 'application-sample-template',
}
